export default {
  Gradebook: "Bulletin de notes",
  Gradebooks: "Bulletins de notes",
  edit_gradebook: "Saisie des bulletins de notes",
  gradebook_finalization: "Finalisation des bulletins de notes",
  empty_gradebook: "Aucun bulletin de note n'existe pour le moment",
  empty_gradebook_subject: "Aucune matière n'est renseignée pour cette période",
  empty_gradebook_subject_exam: "Aucun examen n'est renseigné pour cette matière",
  classroom: "Classe",
  gradebook: {
    absent: "Absent",
    coefficient: {
      short: "Coef",
    },
    mark: "Note",
    appreciation: "Appréciation",
    appreciations: "Appréciations",
    success: "Votre modification a été traitée avec succès !",
    min: "Min",
    max: "Max",
    average: {
      short: "Moy",
      session: "Moyenne sur la période",
    },
    export: {
      excel: {
        title: "Exporter le bulletin de note en Excel",
        confirmation: "Êtes-vous sûr de vouloir exporter les bulletins de notes de cette promotion en Excel ?",
      },
      pdf: {
        title: "Exporter le bulletin de note en pdf",
        confirmation: "Êtes-vous sûr de vouloir exporter le bulletin de notes de ce trinôme en pdf ?",
        all: {
          title: "Exporter tous les bulletins de notes en pdf",
          confirmation: "Êtes-vous sûr de vouloir exporter les bulletins de notes de cette promotion en pdf ?",
        },
      },
    },
    comment: {
      title: "Appréciation",
      general: "Appréciation générale",
      placeholder: "Ajouter une appréciation (optionnel)",
    },
    session: {
      is_valid: "Cette session est validée, elle est visible par les membres des trinômes",
      is_not_valid: "Cette session n'est pas encore validée, elle n'est pas visible par les membres des trinômes",
      valid: "Publier les notes de la session active",
      unlock: "Débloquer la session active",
      valid_confirmation: "Êtes vous sûr de vouloir valider la saisie la session active ?",
      unlock_confirmation: "Êtes vous sûr de vouloir débloquer la saisie de la session active ?",
      valid_success: "Session publiée avec succès !",
      unlock_success: "Session débloquée avec succès !",
      already_pulished: "Cette session est déjà publiée, vous ne pouvez pas la modifier",
      ended: "Cette session est passée, il n'est pas possible de la publier",
    },
    triad: {
      unlock_entry: "Débloquer la saisie de cette note",
      valid_entry: "Valider la saisie de cette note",
      valid_confirmation: "Êtes vous sûr de vouloir valider la saisie de cette note ?",
      unlock_confirmation: "Êtes vous sûr de vouloir débloquer la saisie de cette note ?",
      valid_success: "Note validée avec succès !",
      unlock_success: "Note débloquée avec succès !",
      save_note: "Sauvegarder la saisie de la note",
    },
    exam_type: "Type d'examen",
    percent: {
      title: "Pourcentage de l'examen",
      help: "Poids de la note de l'examen dans le calcul de la note de la matière",
    },
    too_much_percent: "La sommes des pourcentages des examens de cette matière doit être égale à 100",
    percentage: {
      edit: {
        valid: "Valider la saisie des pourcentage",
        success: "Pourcentage enregistré avec succès !",
      },
    },
    ects: "Crédits ECTS",
    empty_subject: "Aucune matière n'est renseignée, veuillez d'abord en ajouter en cliquand ici",
    exempt: "Dispensé",
    reminder: {
      title: "Relancer le formateur",
      confirmation: "Êtes-souv sur de vouloir relancer ce formateur ?",
      success: "Relance effetcuée avec succès !",
    },
    formers: {
      title: "Formateurs",
    },
    write_by: ({ named }) => `Saisie par ${named("user")}`,
    write_on: ({ named }) => `, le ${named("date")}`,
    exemption: "Dispense",
  },
};
